module.exports = {"370215001":"环秀街道","370215002":"潮海街道","370215003":"通济街道","370215004":"北安街道","370215005":"龙山街道","370215006":"龙泉街道","370215007":"鳌山卫街道","370215008":"温泉街道","370215100":"田横镇","370215101":"金口镇","370215102":"灵山镇","370215103":"段泊岚镇","370215104":"移风店镇","370215105":"蓝村镇","370215106":"大信镇","370215400":"通济新经济区","370215401":"青岛蓝谷高新技术产业开发区","370215402":"田横岛省级旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370215.json
// module id = 1370
// module chunks = 0